import { render, staticRenderFns } from "./MetadataInputField.vue?vue&type=template&id=7f535772&scoped=true"
import script from "./MetadataInputField.vue?vue&type=script&lang=js"
export * from "./MetadataInputField.vue?vue&type=script&lang=js"
import style0 from "./MetadataInputField.vue?vue&type=style&index=0&id=7f535772&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f535772",
  null
  
)

export default component.exports